module.exports = __webpack_public_path__ + "img/first_background.5733624f.png";